import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/service/auth.service';
import { MasterPatientsCareService } from 'src/app/patients-care/Service/master-patients-care.service';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent {
  headerMenuList: any = [];
  constructor(private authService: AuthService,private router: Router,private masterservice: MasterPatientsCareService,) {
    // this.headerMenuList = this.authService.headerMenu;
    this.authService.headerMenuListSubject.subscribe((res) => {
      this.headerMenuList = this.authService.headerMenu;

    });
  }

  setPermission(permission:any,menuLinkId:any){
    localStorage.setItem("permission", permission);
    localStorage.setItem("menuLinkId", menuLinkId);
    console.log("menuLinkId>>>",menuLinkId)
    // this.masterservice.setMenulink(menuLinkId);


  }

  checkActivelink(menu){
    const currentUrl = this.normalizeUrl(this.router.url);
    const menuUrl = this.normalizeUrl(menu.functionURL);

    const isActiveRoute = this.isSameOrChildRoute(currentUrl, menuUrl);

    if(menu.menuLinkId === parseInt(localStorage.getItem("menuLinkId")) || isActiveRoute ){
      localStorage.setItem("menuLinkId", menu.menuLinkId);
      return "primary-color"
    }return '';
  }

  private normalizeUrl(url: string): string {
    return String(url || '')
      .split('?')[0]
      .split('#')[0]
      .replace(/\/+$/, '');
  }

  private isSameOrChildRoute(currentUrl: string, menuUrl: string): boolean {
    if (!currentUrl || !menuUrl) {
      return false;
    }

    if (currentUrl === menuUrl) {
      return true;
    }

    const currentSegments = currentUrl.split('/').filter(Boolean);
    const menuSegments = menuUrl.split('/').filter(Boolean);

    if (currentSegments.length < menuSegments.length) {
      return false;
    }

    return menuSegments.every((segment, index) => currentSegments[index] === segment);
  }
}
